import { ReactNode } from 'react';
import BannerOnlineProperty from './img/banner-online-property.webp';
import styles from './PublicAuthLayout.module.scss';

interface PublicAuthLayoutProps {
  children: ReactNode;
  variant?: 'default' | 'auth';
}

interface PublicAuthPageLayoutProps {
  children: ReactNode;
  header: ReactNode;
  authSwitch: ReactNode;
}

export const PublicAuthLayout = ({ children, variant = 'default' }: PublicAuthLayoutProps) => {
  const isAuthLayout = variant === 'auth';

  return (
    <div className={styles.layout} data-qa='public-auth-layout' data-variant={variant}>
      <section
        className={`${styles.contentPanel} ${isAuthLayout ? styles.contentPanelAuth : ''}`}
        data-qa='public-auth-panel'
      >
        <div
          className={`${styles.contentBlock} ${isAuthLayout ? styles.contentBlockAuth : ''}`}
          data-qa='public-auth-content-block'
        >
          <div className={styles.content} data-qa='public-auth-content'>
            {children}
          </div>
        </div>
      </section>

      <aside className={styles.promoPanel} data-qa='public-auth-promo' aria-label='Online Property'>
        <img
          className={styles.promoImage}
          src={BannerOnlineProperty}
          alt='Online Property mobile listing preview'
        />
      </aside>
    </div>
  );
};

export const PublicAuthPageLayout = ({
  children,
  header,
  authSwitch,
}: PublicAuthPageLayoutProps) => (
  <div className={styles.authPage} data-qa='public-auth-page'>
    <header className={styles.authHeader} data-qa='public-auth-header'>
      {header}
    </header>
    <div className={styles.authMain} data-qa='public-auth-form'>
      <div className={styles.authMainContent}>{children}</div>
    </div>
    <footer className={styles.authSwitch} data-qa='public-auth-switch'>
      {authSwitch}
    </footer>
  </div>
);
